<template>
  <div class="app-order-options">
    <slot name="txtBefore"></slot>
    <div class="order-step">
      <div class="inner-accordion-header">
        <slot name="txtInnerAccordionHeaderOptions">SIM-Auswahl</slot>
        <b-btn class="inner-accordion-toggle" @click="visibleOptionsAcc = !visibleOptionsAcc">
          <slot name="btnToggleOpen" v-if="visibleOptionsAcc">minimieren</slot>
          <slot name="btnToggleClosed" v-if="!visibleOptionsAcc">öffnen</slot>
        </b-btn>
      </div>
      <b-collapse v-model="visibleOptionsAcc">
        <slot name="txtBeforeOptions"></slot>
        <b-form-radio-group name="optionSelection" class="rows" v-model="optionSelected" v-if="visibleOptionsAcc">
          <b-form-radio v-for="option in options" :key="option.productNumber" :value="option">
            <dyn-slot :slot-data="{ option: option }"><slot name="simOptionRadio">{{option.name}},{{option.price}}</slot></dyn-slot>
          </b-form-radio>
        </b-form-radio-group>
        <slot name="txtAfterOptions"></slot>
        <BalanceInfo :balance="customerBalance">
          <template v-for="slot in possibleChildSlotsFor('Balance')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </BalanceInfo>
      </b-collapse>

      <div class="inner-accordion-header">
        <slot name="txtInnerAccordionHeaderActivated">Soll deine Ersatz SIM-Karte bereits für dich aktiviert werden?</slot>
        <b-btn class="inner-accordion-toggle" @click="visibleActivateAcc = !visibleActivateAcc">
          <slot name="btnToggleOpen" v-if="visibleActivateAcc">minimieren</slot>
          <slot name="btnToggleClosed" v-if="!visibleActivateAcc">öffnen</slot>
        </b-btn>
      </div>
      <b-collapse v-model="visibleActivateAcc">
        <div v-if="visibleActivateAcc">
          <slot name="txtBeforeActivated"></slot>
          <b-form-radio-group name="activatedSelection" class="rows">
            <b-form-radio v-model="activatedSelected" :value="true"><slot name="activatedRadio">aktiviert</slot></b-form-radio>
            <b-form-radio v-model="activatedSelected" :value="false"><slot name="deactivatedRadio">deaktiviert</slot></b-form-radio>
          </b-form-radio-group>
          <slot name="txtAfterActivated"></slot>
        </div>
      </b-collapse>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" class="btn-next" type="button" variant="primary">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import slotProxy from '@/mixins/slotProxy'
import { mapMutations } from 'vuex/dist/vuex.mjs'
import BalanceInfo from '../../../Tariff/lidl/BalanceInfo.vue'

export const stepName = 'options'
export default {
  name: 'OrderOptions',
  mixins: [
    slotProxy()
  ],
  components: {
    BalanceInfo,
    BButton
  },
  computed: {
  },
  data () {
    return {
      loading: false,
      optionSelected: this.options[0] || {},
      activatedSelected: true,
      visibleOptionsAcc: true,
      visibleActivateAcc: true
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep', 'setSelected'
    ]),
    async next () {
      this.loading = true
      this.setSelected({
        option: this.optionSelected,
        activatedSimBeforeDelivery: this.activatedSelected
      })
      this.changeStep({ step: this.nextStep })
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'summary'
    },
    options: {
      type: Array,
      default: () => { return [] }
    },
    customerBalance: {
      type: Number,
      default: 0
    }
  }
}
</script>
